module.exports = __webpack_public_path__ + "static/img/logo_42.44d60f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_42.png
// module id = pVxK
// module chunks = 1